export type AttributeItem = { [key: string]: string };

/* It will Wait for the New Relic to be available in the browser and returns it */
function getNewRelic(): Promise<any> {
    return new Promise(resolve => {
        const nr = (window as any).newrelic;
        if (nr) {
            resolve(nr);
        } else {
            setTimeout(() => {
                const retryNr = (window as any).newrelic;
                resolve(retryNr || null); // resolve null if still not available
            }, 300); // wait 300ms before retry
        }
    });
}

/*Sends a custom event to New Relic for tracking */
export async function logInteraction(interactionName: string, actionText: string, attributes: Array<AttributeItem> = []) {
    const newRelic = await getNewRelic();
    try {
        if (!newRelic) {
            console.warn('New Relic not available yet.');
            return;
        }

        // ✅ Create interaction
        const interaction = newRelic.interaction();

        interaction.actionText(actionText);
        interaction.setName(interactionName);

        // ✅ Set attributes from array only if the array length is >0
        if (attributes.length > 0) {
            attributes.forEach(attr => {
                const [key, value] = Object.entries(attr)[0];
                interaction.setAttribute(key, value);
            });
        }

        // ✅ Save interaction
        interaction.save();
        console.log(`New Relic Interaction saved: ${interactionName}`, attributes);
    } catch (e) {
        console.error('Error logging interaction to New Relic:', e);
    }
}



